import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button} from "reactstrap";
import CardHeader from "@material-ui/core/CardHeader";
import Select from "react-select";
import API from "@beardeddevops/react.api";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import moment from "moment";

class Video extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Videos._name);
		this.state.sub_categories = [];
		this.state.categories = [];
		this.state.selectedSubCategory = null;
		this.state.isGeneric = true;
		this.state.userRoles = this.props.userRoles;
		this.state.selectedUserRoles = [];
		this.state.shouldPlay = false;
		this.state.elapsed = 0;
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getCategories();
		if (this.state.category) {
			await this.getSubCategories(this.state.category)
		}
	}

	componentDidUpdate(prevState, prevProps, snapshot) {
		if (this.state.user_accesses.length > 1 && this.state.selectedUserRoles.length === 0 && this.state.userRoles) {
			this.setState({
				selectedUserRoles: this.state.user_accesses.split(',').map((access) => {
					const foundRole = this.state.userRoles.find((role) => role.value == access);
					return {value: foundRole.value, label: foundRole.name}
				})
			})
		}
	}

	getSubCategories = async (category) => {
		let model = new API.BuildClass(Types.Categories_Subs._name, API.RequestType.READ);
		this.read = 'GET_BY_CATEGORY';
		model.parent = category;
		this.data = await model.submit(null, this.read);
		this.setState({
			sub_categories: this.data.items
		});
	}

	getCategories = async () => {
		let model = new API.BuildClass(Types.Categories._name, API.RequestType.READ_ALL);
		this.data = await model.submit(null, API.RequestType.READ_ALL);
		this.setState({
			categories: this.data.items
		});
	}

	handleRoles = async (value) => {
		if (value) {
			let roles = [];
			for (let i = 0; i < value.length; i++) {
				roles.splice(0, 0, value[i]);
			}
			this.state.selectedUserRoles = roles;
		} else {
			this.state.selectedUserRoles = [];
		}
		this.setState({
			user_accesses: this.state.selectedUserRoles.map((role => {
				return role.value
			})).join(',')
		})
	}

	handleUrl = (property, value) => {
		value = value.replace('watch?v=', 'embed/');
		value = value.replace('"', '');
		this.handleTextFieldPropertyUpdate(property, value);
	}

	handleSubmit = (event) => {
		if (this.state.user_accesses.length < 1) {
			this.state.user_accesses = '20,25,30,40,50'
		}
		super.handleSubmit(event, false, false)
	}


	render() {
		const {properties} = this.model;
		let object = this.state;

		return (
			<fieldset>
				{this.props.isNew && <div className={'row pb-2'}>
					<div className={'col-12'}>
						<p>Copy the url directly from the address bar of the video you want. Do not use the short link from share. If you need the
							video to start at a specific time, go to where you want the video to start, click share, click embed, click "Start at
							___", then use the generated url that comes after "src=". It should look something like this:
							https://www.youtube.com/embed/dQw4w9WgXcQ?start=59. The player will automatically add modestbranding=1, showinfo=0,
							autohide=1, showsearch=0, rel=0, and controls=0</p>
						<br/>
					</div>
					<div className={'col-2'}>
						<FormGroup>
							<FormControlLabel control={
								<Checkbox
									checked={this.state.isGeneric}
									onChange={() => {
										this.setState({isGeneric: !this.state.isGeneric})
									}}
									color={'primary'}
								/>
							} label={"Generic"}/>
						</FormGroup>
					</div>
					{!this.state.isGeneric &&
						<>
							<div className={'col-5'}>
								<Select
									key={this.state.categories}
									placeholder={"Category Select"}
									isMulti={false}
									isClearable
									value={this.state.selectedCategory}
									onChange={async (value) => {
										this.setState({
											selectedCategory: value ? value : null,
											category: value ? value.value : null,
											sub_category: null,
											sub_categories: []
										})
										value && await this.getSubCategories(value.value)
									}}
									options={this.state.categories.map(category => {
										return (
											{value: category.pkey, label: category.name})
									})}
									styles={this.styles}
								/>
							</div>
							<div className={'col-5'}>
								<Select
									key={this.state.sub_categories}
									placeholder={"Sub-Category Select"}
									isMulti={false}
									isClearable
									value={this.state.selectedSubCategory}
									onChange={(value) => {
										this.setState({selectedSubCategory: value ? value : null, sub_category: value ? value.value : null})
									}}
									options={this.state.sub_categories.map(category => {
										return (
											{value: category.pkey, label: category.name})
									})}
									styles={this.styles}
								/>
							</div>
						</>
					}
					<div className={'col-6'}>
						<Select
							key={this.state.userRoles}
							placeholder={"Accesses"}
							isMulti={true}
							isClearable={false}
							value={this.state.selectedUserRoles.map(role => {
								return (
									{value: role.value, label: role.label}
								)
							})}
							onChange={this.handleRoles}
							options={this.state.userRoles?.map((role) => {
								return {value: role.value, label: role.name}
							})}
							styles={this.styles}
						/>
					</div>
				</div>}
				<Card>
					<CardHeader title={
						this.props.isNew ? <Framework.Elements.TextField
							property={properties.title}
							value={object.title}
							error={object.title_error}
							update={this.handleTextFieldPropertyUpdate}
							disabled={!this.props.editable && !this.props.isNew}
						/> : <div className={'row'}>
							<div className={'col-9 p-1'}>
								<Framework.Elements.TextField
									property={properties.title}
									value={object.title}
									error={object.title_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={!this.props.editable && !this.props.isNew}
								/>
							</div>
							<div className={'col-3 p-1'}>
								<Button onClick={async () => {
									const prefix = window.location.href.includes('dev.') ? 'dev.' : window.location.href.includes('beta.') ? 'beta.' : 'app.';
									await navigator.clipboard.writeText(prefix + 'karlstechnology.com/videos?video=' + object.pkey);
									API.Toast.info('URL Copied', {
										position: API.Toast.POSITION.TOP_RIGHT
									});
								}} color={'primary'} variant={'contained'}>Copy URL</Button>
							</div>
						</div>
					}/>
					<CardContent style={{position: "relative"}}>
						<div className={'row-' + this.state.pkey}>
							<div className={'col-12'} style={{height: this.props.collection ? '18rem' : '50rem'}}>
								<iframe width={'100%'} height={'100%'}
								        src={object.url + (object.url.includes('?') ? 'modestbranding=1&showinfo=0&autohide=1&showsearch=0&rel=0&controls=0' : '?modestbranding=1&showinfo=0&autohide=1&showsearch=0&rel=0&controls=0') + (this.state.shouldPlay ? '&autoplay=1' : '') + (this.state.elapsed ? `&start=${this.state.elapsed}` : '')}
								        allow={'autoplay; fullscreen'}></iframe>
								<div style={{top: 0, left: 0, width: '100%', height: '100%', position: 'absolute'}} onMouseDown={(event) => {
									if (!this.props.collection) {
										if (event.button !== 0) {
											event.preventDefault();
										} else {
											if (this.state.shouldPlay === false) {
												this.state.played = moment().format()
											} else {
												let diff = moment().diff(this.state.played, 'seconds', true)
												this.state.elapsed += Math.floor(diff);
											}
											this.setState({shouldPlay: !this.state.shouldPlay})
										}
									} else {
										window.open('/videos/' + object.pkey, '_blank').focus();
									}
								}}
								></div>
							</div>
							{(this.props.editable || this.props.isNew) && <div className={'col-12 pt-2'}>
								<Framework.Elements.TextField
									property={properties.url}
									value={object.url}
									error={object.url_error}
									update={this.handleUrl}
								/>
							</div>}
							<div className={'col-12 pt-2'}>
								<Framework.Elements.TextField
									property={properties.information}
									value={object.information}
									error={object.information_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
									disabled={!this.props.editable && !this.props.isNew}
								/>
							</div>
						</div>
						<div className={'row pt-2'}>
							{!this.props.isNew && this.props.editable &&
								<>
									<div className={'col-6'}>
										<Select
											key={this.state.categories}
											placeholder={"Category Select"}
											isMulti={false}
											isClearable
											value={this.state.category ? this.state.categories.map((category) => {
												if (category.pkey === this.state.category) {
													return {value: category.pkey, label: category.name}
												} else {
													return null
												}
											}) : null}
											onChange={async (value) => {
												this.setState({category: value ? value.value : null, sub_category: null, sub_categories: []})
												value && await this.getSubCategories(value.value)
											}}
											options={this.state.categories.map(category => {
												return (
													{value: category.pkey, label: category.name})
											})}
											styles={this.styles}
										/>
									</div>
									<div className={'col-6'}>
										<Select
											key={this.state.sub_categories}
											placeholder={"Sub-Category Select"}
											isMulti={false}
											isClearable
											value={this.state.sub_category ? this.state.sub_categories.map((sub_category) => {
												if (sub_category.pkey === this.state.sub_category) {
													return {value: sub_category.pkey, label: sub_category.name}
												} else {
													return null
												}
											}) : null}
											onChange={(value) => {
												this.setState({sub_category: value ? value.value : null})
											}}
											options={this.state.sub_categories.map(category => {
												return (
													{value: category.pkey, label: category.name})
											})}
											styles={this.styles}
										/>
									</div>
								</>}
						</div>
					</CardContent>
					{!this.props.isNew &&
						<CardActions disableSpacing={true}>
							{!this.props.isNew && this.props.editable && <div style={{marginRight: 'auto', width: '22rem'}}>
								<Select
									key={this.state.userRoles}
									placeholder={"Accesses"}
									isMulti={true}
									isClearable={false}
									value={this.state.selectedUserRoles.map(role => {
										return (
											{value: role.value, label: role.label}
										)
									})}
									onChange={this.handleRoles}
									options={this.state.userRoles?.map((role) => {
										return {value: role.value, label: role.name}
									})}
									styles={this.styles}
								/>
							</div>}
							{this.props.editable && <Button color="danger" onClick={this.handleDelete}>Delete</Button>}
							{this.props.editable && <Button color="primary" onClick={this.handleSubmit}>Save</Button>}

						</CardActions>
					}
				</Card>
			</fieldset>
		)
	}

	customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: 32
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: '1px 6px'
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: 4,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 3,
		})
	};

	styles = {
		...this.customStyles, ...{
			container: (provided) => ({
				...provided,
			}),
			control: (provided) => ({
				...provided,
				minHeight: '30px'
			}),
			valueContainer: (provided) => ({
				...provided,
				overflow: 'visible',
				padding: '1px 8px'
			}),
			placeholder: (provided, state) => ({
				...provided,
				position: "absolute", //(state.hasValue && state.selectProps.value.label) &&
				top: -4,
				left: -4,
				marginLeft: 0,
				marginRight: 0,
				fontSize: '1rem',
				color: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'rgba(0, 0, 0, 0.54)',
				transition: "top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
				transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) ? "translate(14px, -6px) scale(0.75) !important" : "translate(14px, 10px) scale(1) !important",
				transformOrigin: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "top left",
				//transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'matrix(0.75, 0, 0, 0.75, 14, -6)',
				backgroundColor: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'white',
				padding: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && '0 8px',
			}),
			multiValue: (provided) => ({
				...provided,
				zIndex: 2
			})
		}
	};
}

export default Framework.Components.withRootState(Video);
